// src/providers/BrandingProvider.js
import { useMemo } from 'react';
import { ChakraProvider, extendTheme } from '@chakra-ui/react';

export default function BrandingProvider({ children }) {
  // Neutral, fixed theme (no Storage, no dynamic colours)
  const theme = useMemo(
    () =>
      extendTheme({
        initialColorMode: 'light',
        useSystemColorMode: false,
        fonts: {
          heading:
            'Inter, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif',
          body: 'Inter, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif',
        },
        colors: {
          brand: {
            50: '#e7f1ff',
            500: '#2563EB',
            600: '#1D4ED8',
          },
        },
        components: {
          Button: { baseStyle: { rounded: 'xl' } },
          Card: { baseStyle: { rounded: '2xl' } },
        },
      }),
    []
  );

  return <ChakraProvider theme={theme}>{children}</ChakraProvider>;
}
